import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { I18nextProvider } from 'react-i18next'; 
import i18next from 'i18next'; 
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import Homepage from "./Pages/Homepage";
import News from "./Pages/News"; 
import ContactUs from "./Pages/ContactUs";
import NotFound from "./Pages/NotFound";

import global_en from "./translation/en/global.json";
import global_mk from "./translation/mk/global.json";

i18next.init({
  interpolation: { escapeValue: false }, 
  lng: localStorage.getItem('language') || 'mk', 
  resources: {
    en: { global: global_en },
    mk: { global: global_mk },
  },
  fallbackLng: 'mk', 
  ns: ['global'],
  defaultNS: 'global',
});

function App() {
  return (
    <I18nextProvider i18n={i18next}> 
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/news" element={<News />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </Router>
    </I18nextProvider>
  );
}

export default App;
